import { Button, Group, useComputedColorScheme } from "@mantine/core";
import { useEffect } from "react";
import { getTestQuestionStatusBadgeStyle } from "./QuestionQuickJumpCard";
import classes from "./TestMarkingLegend.module.css";

export default function TestMarkingLegend({
  questionCount,
  testMarks,
  onAllMarkingComplete,
}: {
  questionCount: number;
  testMarks: { [questionId: string]: number | undefined };
  onAllMarkingComplete?: () => void;
}) {
  const colorScheme = useComputedColorScheme("light");
  const isDark = colorScheme === "dark";
  const allMarkingComplete = (testMarks as any).length === questionCount;

  useEffect(() => {
    if (allMarkingComplete && onAllMarkingComplete) {
      onAllMarkingComplete();
    }
  }, [allMarkingComplete]);

  return (
    <Group>
      <Button
        {...getTestQuestionStatusBadgeStyle(isDark, "marking", false, true)}
        size="compact-xs"
        className={classes.staticButton}
      >
        Unmarked
      </Button>
      <Button
        {...getTestQuestionStatusBadgeStyle(isDark, "marking", true, true)}
        size="compact-xs"
        style={{ transform: "none", pointerEvents: "none" }}
      >
        Marked
      </Button>
    </Group>
  );
}
